
import authStore from './auth/AuthStore';

const stores = {
    authStore
};

export default stores;